module.exports = __webpack_public_path__ + "static/media/flight-search.74a66f04.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/flight-search.mp4
// module id = 849
// module chunks = 0